import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  FetchSubjectByIdRequest,
  UpdateSubjectRequest,
  FetchSubjectsRequest,
  CreateSubjectRequest,
  DeleteSubjectRequest,
  SuspendSubjectRequest,
  ActivateSubjectRequest,
  FetchAllSubjectsRequest,
} from './types'
import {AxiosError} from 'axios'
import {ResponseError} from '../commonTypes'
import {Subject} from '../../../models'
import axios from 'axios'
import {
  fetchSubjectsUrl,
  fetchSubjectByIdUrl,
  createSubjectUrl,
  updateSubjectUrl,
  deleteSubjectUrl,
  suspendSubjectUrl,
  activateSubjectUrl,
  fetchAllSubjectsUrl,
} from '../../api'

function normalizeSubject(subject: Subject): Subject {
  return {
    ...subject,
    hasNationalExams: Boolean(subject.hasNationalExams),
  }
}

function normalizeSubjects(subjects: Subject[]): Subject[] {
  return subjects.map((subject) => normalizeSubject(subject))
}

export const fetchSubjects = createAsyncThunk(
  'subject/fetch',
  async (payload: FetchSubjectsRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchSubjectsUrl}?sortField=${payload.sortField}&sortOrder=${
          payload.sortOrder
        }&pageNumber=${payload.pageNumber}&pageCount=${payload.pageCount}${
          payload.search && payload.search.trim() !== '' ? '&search=' + payload.search.trim() : ''
        }`
      )
      const {subjects, totalPages, total} = res.data
      return {
        subjects: normalizeSubjects(subjects),
        totalPages,
        total,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchAllSubjects = createAsyncThunk(
  'subject/fetchAllSubject',
  async (payload: FetchAllSubjectsRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchAllSubjectsUrl}`)
      const {subjects} = res.data
      return {
        subjects: normalizeSubjects(subjects),
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchSubjectById = createAsyncThunk(
  'subject/fetchById',
  async (payload: FetchSubjectByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchSubjectByIdUrl}/${payload.id}`)
      const {subject} = res.data
      return {
        subject: normalizeSubject(subject),
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const createSubject = createAsyncThunk(
  'subject/create',
  async (payload: CreateSubjectRequest, {rejectWithValue}) => {
    try {
      const body = {
        ...payload,
        hasNationalExams: Boolean(payload.hasNationalExams),
      }
      const res = await axios.post(createSubjectUrl, body)
      const {subject} = res.data
      return {
        subject: normalizeSubject(subject),
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const updateSubject = createAsyncThunk(
  'subject/update',
  async (payload: UpdateSubjectRequest, {rejectWithValue}) => {
    try {
      const body = {
        ...payload,
        hasNationalExams: Boolean(payload.hasNationalExams),
      }
      const res = await axios.post(updateSubjectUrl, body)
      const {subject} = res.data
      return {
        subject: normalizeSubject(subject),
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const deleteSubject = createAsyncThunk(
  'subject/delete',
  async (payload: DeleteSubjectRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(deleteSubjectUrl, payload)
      const {subject} = res.data
      return {
        subject: normalizeSubject(subject),
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const suspendSubject = createAsyncThunk(
  'subject/suspend',
  async (payload: SuspendSubjectRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(suspendSubjectUrl, payload)
      const {subject} = res.data
      return {
        subject: normalizeSubject(subject),
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const activateSubject = createAsyncThunk(
  'subject/activate',
  async (payload: ActivateSubjectRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(activateSubjectUrl, payload)
      const {subject} = res.data
      return {
        subject: normalizeSubject(subject),
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)
